import * as React from 'react';
import { Alert, Avatar, Box, Button, Card, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Stack, TextField, Typography } from '@mui/material';
import $ from "jquery";
import Common from '../../utilities/common';
import Layout from '../../components/Utilities/Layout';
import { User } from './User';
import EntitySettings from '../../components/EntitySettings';
import SecurityTrimmer from '../../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../../utilities/Permisos';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import ColorLensOutlinedIcon from '@mui/icons-material/ColorLensOutlined';
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import { ColorResult, ChromePicker, PhotoshopPicker  } from 'react-color';
import { json } from 'stream/consumers';

export interface IUserState {
    user: User | null,
    openColorPicker: boolean;
    editMode: boolean;
    openChangePasswordDialog: boolean;
    newPassword: string;
    repeatPassword: string;
    oldPassword: string;
    openConfirmChangePasswordDialog: boolean;
}

export default class UserProfile extends React.Component<{}, IUserState> {
    _file: any;
    _fileContent: any[] = [];
    _errors: string[] = [];

    public constructor(props: {}) {
        super(props);

        this.state = {
            user: null,
            editMode: false,
            openColorPicker: false,
            openChangePasswordDialog: false,
            newPassword: '',
            repeatPassword: '',
            oldPassword: '',
            openConfirmChangePasswordDialog: false
        };
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <div>
                <Layout>
                    <Box className='stepper'>
                        <Grid container>
                            <Grid item xs={1}>
                                <Typography>
                                    <AssignmentIndOutlinedIcon className='mainIcon'/>
                                </Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography className='mainTitle'>
                                Mi perfil
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box className='main'>
                        <Grid container spacing={3}>
                            <Grid item xs={4}>
                                {
                                    this.state.user != null && (
                                        <React.Fragment>
                                            <div style={{border: 'solid 1px #f4f4f4', padding: '10px', borderRadius: '5px', boxShadow: '0px 9px 14px -14px rgba(0, 0, 0, .7)', backgroundColor: '#fafafa'}}>
                                                <Avatar src={this.state.user.avatar} sx={{ width: 250, height: 250, bgcolor: this.state.user.avatarColor, position: 'relative', left: '50%', transform: 'translateX(-50%)' }}>
                                                    <Typography variant='h1' style={{position: 'relative', top: '2px'}}>
                                                        {
                                                            Common.GetNameInitials(`${this.state.user.nombre} ${this.state.user.apellidos}`)
                                                        }
                                                    </Typography>
                                                </Avatar>
                                            </div>
                                            <Stack direction='row' justifyContent={'space-between'}>
                                                <Button variant='text' startIcon={<ColorLensOutlinedIcon/>} onClick={() => {
                                                    this.setState(
                                                        {
                                                            openColorPicker: true
                                                        }
                                                    )
                                                }}>
                                                    {
                                                        !Common.IsNullOrEmpty(this.state.user.avatar) && (
                                                            `Asignar color`
                                                        )
                                                    }
                                                    {
                                                        Common.IsNullOrEmpty(this.state.user.avatar) && (
                                                            `Cambiar color`
                                                        )
                                                    }
                                                </Button>
                                                <Button variant='text' startIcon={<AccountBoxOutlinedIcon/>} onClick={() => {
                                                    document.getElementById('fileImage')?.click();
                                                }}>
                                                    {
                                                        Common.IsNullOrEmpty(this.state.user.avatar) && (
                                                            `Asignar imagen`
                                                        )
                                                    }
                                                    {
                                                        !Common.IsNullOrEmpty(this.state.user.avatar) && (
                                                            `Cambiar imagen`
                                                        )
                                                    }
                                                </Button>
                                                <input type="file" id="fileImage" style={{display: 'none'}} accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*" onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                                                    const files = (e.target as HTMLInputElement).files;
                                                    const fileReader = new FileReader();
                                                    fileReader.addEventListener("load", (evt) => {
                                                        const user = this.state.user;
                                                        const result: string | ArrayBuffer | null = evt.target!.result;
                                                        
                                                        user!.avatar = result!.toString();
                        
                                                        this.setState(
                                                            {
                                                                user: user
                                                            }
                                                        )
                                                    });

                                                    fileReader.readAsDataURL(files![0]);
                                                }}/>
                                            </Stack>
                                            <Dialog open={this.state.openColorPicker}>
                                                <DialogContent>
                                                    <PhotoshopPicker color={this.state.user?.avatarColor} 
                                                    onAccept={() => {
                                                        this.setState(
                                                            {
                                                                openColorPicker: false
                                                            }
                                                        )
                                                    }} 
                                                    onChangeComplete={(color: ColorResult) => {
                                                        const user = this.state.user;
                                                        user!.avatarColor = color.hex;
                                                        user!.avatar = '';
                        
                                                        this.setState(
                                                            {
                                                                user: user
                                                            }
                                                        )
                                                    }}/>
                                                </DialogContent>
                                            </Dialog>
                                        </React.Fragment>
                                    )
                                }
                            </Grid>
                            <Grid item xs={8}>
                                {
                                    this.state.user != null && (
                                        <React.Fragment>
                                            <Typography variant='h6' fontWeight={500} component={'span'} style={{marginRight: '10px'}}>Nombre:</Typography>
                                            {
                                                !this.state.editMode && (
                                                    <Typography variant='h6' fontWeight={100} component={'span'}>
                                                        {
                                                            this.state.user.nombre
                                                        }
                                                    </Typography>
                                                )
                                            }
                                            {
                                                this.state.editMode && (
                                                    <TextField variant="standard" defaultValue={this.state.user.nombre} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                        const user = this.state.user;
                                                        user!.nombre = event.target.value;
                        
                                                        this.setState(
                                                            {
                                                                user: user
                                                            }
                                                        )
                                                    }}/>
                                                )
                                            }
                                            <br/>
                                            <Typography variant='h6' fontWeight={500} component={'span'} style={{marginRight: '10px'}}>Apellidos:</Typography>
                                            {
                                                !this.state.editMode && (
                                                    <Typography variant='h6' fontWeight={100} component={'span'}>
                                                        {
                                                            this.state.user.apellidos
                                                        }
                                                    </Typography>
                                                )
                                            }
                                            {
                                                this.state.editMode && (
                                                    <TextField variant="standard" defaultValue={this.state.user.apellidos} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                        const user = this.state.user;
                                                        user!.apellidos = event.target.value;
                        
                                                        this.setState(
                                                            {
                                                                user: user
                                                            }
                                                        )
                                                    }}/>
                                                )
                                            }
                                            <br/>
                                            <Typography variant='h6' fontWeight={500} component={'span'} style={{marginRight: '10px'}}>Email:</Typography>
                                            {
                                                !this.state.editMode && (
                                                    <Typography variant='h6' fontWeight={100} component={'span'}>
                                                        {
                                                            this.state.user.userName
                                                        }
                                                    </Typography>
                                                )
                                            }
                                            {
                                                this.state.editMode && (
                                                    <TextField variant="standard" defaultValue={this.state.user.userName} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                        const user = this.state.user;
                                                        user!.userName = event.target.value;
                        
                                                        this.setState(
                                                            {
                                                                user: user
                                                            }
                                                        )
                                                    }}/>
                                                )
                                            }
                                        </React.Fragment>
                                    )
                                }
                            </Grid>
                        </Grid>
                    </Box>
                    <Box className='stepper'>
                        <div className='textRight'>
                            {
                                !this.state.editMode && (
                                    <Button variant='contained' onClick={() => {
                                        this.setState(
                                            {
                                                editMode: true
                                            }
                                        )
                                    }}>Editar datos</Button>
                                )
                            }
                            {
                                this.state.editMode && (
                                    <Button variant='contained' onClick={() => {
                                        this.setState(
                                            {
                                                editMode: false
                                            }
                                        )
                                    }}>Cancelar</Button>
                                )
                            }
                            <Button variant='contained' onClick={this.Update.bind(this)}>Guardar</Button>
                            <Button variant='contained' onClick={() => {
                                this.setState(
                                    {
                                        openChangePasswordDialog: true
                                    }
                                )
                            }}>Cambiar contraseña</Button>
                        </div>
                    </Box>
                    <Dialog open={this.state.openChangePasswordDialog} fullWidth>
                        <DialogTitle>
                            Cambio de contraseña
                        </DialogTitle>
                        <DialogContent>
                            <TextField required label="Contraseña antigua" type="password" fullWidth variant="standard"  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                this.setState(
                                    {
                                        oldPassword: event.target.value
                                    }
                                )
                            }}/>
                            <TextField required label="Contraseña nueva" type="password" fullWidth variant="standard" onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                this.setState(
                                    {
                                        newPassword: event.target.value
                                    }
                                )
                            }}/>
                            <TextField required label="Repita la contraseña nueva" type="password" fullWidth variant="standard" onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                this.setState(
                                    {
                                        repeatPassword: event.target.value
                                    }
                                )
                            }}/>
                            {
                                !Common.IsNullOrEmpty(this.state.newPassword) && !Common.IsNullOrEmpty(this.state.repeatPassword) && (this.state.newPassword != this.state.repeatPassword) && (
                                    <Alert severity='error' style={{marginTop: '20px'}}>
                                        Las contraseñas no coinciden
                                    </Alert>
                                )
                            }
                        </DialogContent>
                        <DialogActions>
                            <Button variant='contained' disabled={Common.IsNullOrEmpty(this.state.oldPassword) || Common.IsNullOrEmpty(this.state.newPassword) || Common.IsNullOrEmpty(this.state.repeatPassword) || (this.state.newPassword != this.state.repeatPassword)} onClick={() => {
                                this.setState(
                                    {
                                        openConfirmChangePasswordDialog: true
                                    }
                                )
                            }}>Ok</Button>
                            <Button variant='contained' onClick={() => {
                                this.setState(
                                    {
                                        openChangePasswordDialog: false
                                    }
                                )
                            }}>Cancelar</Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog open={this.state.openConfirmChangePasswordDialog} fullWidth hideBackdrop>
                        <DialogTitle>
                            Confirmación de cambio de contraseña
                        </DialogTitle>
                        <DialogContent>
                            <Typography variant='body2'>
                            Al cambiar la contraseña se cerrará su sesión y se le redirigirá a la página de inicio de sesión.
                            </Typography>
                            <Typography variant='body2'>
                            ¿Desea continuar con el cambio de contraseña?
                            </Typography>
                        </DialogContent>
                        <DialogActions>
                            <Button variant='contained' onClick={this.ChangePassword.bind(this)}>Ok</Button>
                            <Button variant='contained' onClick={() => {
                                this.setState(
                                    {
                                        openChangePasswordDialog: false,
                                        openConfirmChangePasswordDialog: false
                                    }
                                )
                            }}>Cancelar</Button>
                        </DialogActions>
                    </Dialog>
                </Layout>
            </div>
        )
    }

    private Get(): void {
        const userId = Common.GetUserProp('id');
        let url = `${Common.END_POINT}/masters/users/${userId}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: User[]) => {
            console.log(response);
            this.setState(
                {
                    user: response[0]
                }
            );
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            console.log(jqXHR);
        });
    }

    private Update(): void {
        const userId = Common.GetUserProp('id');
        const user: User | null = this.state.user;

        if(user?.avatar.indexOf == undefined) {
            user!.avatar = '';
        }

        let url = `${Common.END_POINT}/masters/users/${userId}/update`;
        
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(user),
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any) => {
            let userLocalStorage = JSON.parse(localStorage.getItem("user")!);
            userLocalStorage.usuario = user;
            
            localStorage.setItem('user', JSON.stringify(userLocalStorage));

            window.location.reload();
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            console.log(jqXHR);
        });
    }

    private ChangePassword(): void {
        const userId = Common.GetUserProp('id');
        const changePasswordModel: any = {};
        changePasswordModel.oldPassword = this.state.oldPassword;
        changePasswordModel.newPassword = this.state.newPassword;

        let url = `${Common.END_POINT}/masters/users/${userId}/changepassword`;
        
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(changePasswordModel),
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any) => {
            localStorage.removeItem('user');
            window.location.href = '/login';
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            console.log(jqXHR);
        });
    }
}